module.exports = __webpack_public_path__ + "img/e3.52860118.jpg";